"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserConfigTimeZoneType = void 0;
var UserConfigTimeZoneType;
(function (UserConfigTimeZoneType) {
    UserConfigTimeZoneType["User"] = "User Time Zone";
    UserConfigTimeZoneType["Squadron"] = "Squadron Time Zone";
})(UserConfigTimeZoneType = exports.UserConfigTimeZoneType || (exports.UserConfigTimeZoneType = {}));
